<template>
  <div class="mainContet">
    <div id="container" class="map_area"></div>
  </div>
</template>
<script>
export default {
  name: "mapResultMobile",
  data() {
    return {
      mapLanguage: "",
      map: null,
      hotelData: null,
    };
  },
  watch: {
    "$i18n.locale"() {
      this.initMap();
    },
  },
  mounted() {
    this.hotelData = JSON.parse(sessionStorage.getItem("mapData"));
    this.initMap();
  },
  methods: {
    openInfo(e) {
      if (this.$i18n.locale === "en") {
        this.info = [];
        this.info.push(`<div onclick = 'transfer(${JSON.stringify(
          this.hotelData.hotelDescriptiveInfo
        )})'><div style="font-size:1.6rem; cursor:pointer;">${
          this.hotelData.hotelDescriptiveInfo.name["en"]
        }</div>
                      <div>`);
        // for (
        //   let i = 0;
        //   i < this.hotelData.hotelDescriptiveInfo.starRating;
        //   i++
        // ) {
        //   this.info
        //     .push(` <svg class="svg-icon icon-star" style="height:1.5rem;width:1.5rem; float:left; padding-top:0.2rem; cursor:pointer">
        //                                   <use xlink:href="#icon-star"></use></svg>`);
        // }
        for (let i = 1; i <= 5; i++) {
          if (this.hotelData.hotelDescriptiveInfo.starRating >= i) {
            this.info.push(`<span class="el-rate__item" style="cursor: auto;"><i class="el-rate__icon el-icon-star-on" style="color: #F2A900;margin-right: 0;"></i></span>`);
          } else if (this.hotelData.hotelDescriptiveInfo.starRating > i - 1 && this.hotelData.hotelDescriptiveInfo.starRating < i) {
            this.info.push(`<span class="el-rate__item" style="cursor: auto;"><i class="el-rate__icon el-icon-star-on" style="color: #F2A900;margin-right: 0;"><i class="el-rate__decimal el-icon-star-on" style="color: #F2A900; width: 50%;"></i></i></span>`);
          } else {
            this.info.push(`<span class="el-rate__item" style="cursor: auto;"><i class="el-rate__icon el-icon-star-on" style="color: #F2A900;margin-right: 0;"></i></span>`);
          }
        }
        this.info.push(`</div>
                     <div style="color:#FC6640; font-size:1.8rem; float:left;cursor:pointer">From ${ this.$objBaseInfo.defaultCurrencySign + this.hotelData.averagePrice}</div>
                       </div>
                    `);
      } else {
        this.info = [];
        this.info.push(`<div onclick = 'transfer(${JSON.stringify(
          this.hotelData.hotelDescriptiveInfo
        )})'><div style="font-size:1.6rem; cursor:pointer;">${
          this.hotelData.hotelDescriptiveInfo.name["zh-CN"]
        }</div>
                      <div>`);
        // for (
        //   let i = 0;
        //   i < that.hotelData.hotelDescriptiveInfo.starRating;
        //   i++
        // ) {
        //   that.info
        //     .push(` <svg class="svg-icon icon-star" style="height:1.5rem;width:1.5rem; float:left; padding-top:0.2rem; cursor:pointer">
        //                                   <use xlink:href="#icon-star"></use></svg>`);
        // }
        for (let i = 1; i <= 5; i++) {
          if (this.hotelData.hotelDescriptiveInfo.starRating >= i) {
            this.info.push(`<span class="el-rate__item" style="cursor: auto;"><i class="el-rate__icon el-icon-star-on" style="color: #F2A900;margin-right: 0;"></i></span>`);
          } else if (this.hotelData.hotelDescriptiveInfo.starRating > i - 1 && this.hotelData.hotelDescriptiveInfo.starRating < i) {
            this.info.push(`<span class="el-rate__item" style="cursor: auto;"><i class="el-rate__icon el-icon-star-on" style="color: #F2A900;margin-right: 0;"><i class="el-rate__decimal el-icon-star-on" style="color: #F2A900; width: 50%;"></i></i></span>`);
          } else {
            this.info.push(`<span class="el-rate__item" style="cursor: auto;"><i class="el-rate__icon el-icon-star-on" style="color: #F2A900;margin-right: 0;"></i></span>`);
          }
        }

        this.info.push(`</div>
                     <div style="color:#FC6640; font-size:1.8rem; float:left;cursor:pointer">${ this.$objBaseInfo.defaultCurrencySign + this.hotelData.averagePrice} 起</div>
                       </div>
                    `);
      }
      this.infoWindow = new AMap.InfoWindow({
        content: this.info.join(""), //使用默认信息窗体框样式，显示信息内容
      });

      this.infoWindow.open(
        this.map,
        e ? e.target.getPosition() : this.map.getCenter()
      );
      this.$forceUpdate();
    },
    initMap() {
      let foreignLang = "style_zh_cn";
      if (this.$i18n.locale === "en") {
        this.mapLanguage = "en";
        foreignLang = "style_en";
      } else {
        this.mapLanguage = "zh_cn";
        foreignLang = "style_zh_cn";
      }
      // 获取 类别为GPS 的 location经纬度
      let latitude = this.hotelData.hotelDescriptiveInfo.location[1].latitude;
      let longitude = this.hotelData.hotelDescriptiveInfo.location[1].longitude;
      this.map = new AMap.Map("container", {
        zoom: 16,
        center: [longitude, latitude],
        resizeEnable: true,
        vectorMapForeign: foreignLang,
        lang: this.mapLanguage,
      });
      this.positions = [longitude, latitude];
      let marker = [];
      marker = new AMap.Marker({
        position: this.positions,
      });
      this.map.add(marker);
      marker.on("click", this.openInfo);
      this.openInfo();
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 960px) {
  ::v-deep .amap-info-content {
    width: 100%;
    height: 100%;
  }
  .mainContet {
    width: 100%;
    height: 70vh;
  }
  .map_area {
    margin-top: 5%;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
